import request from '@/utils/request'

// 下载重定向
export const resourceDownload = (params) => {
    return request({
        url: '/ypt/resource/info/resourceDownload',
        method: 'get',
        params,
        responseType: 'blob'
    })
}

// 证书查询
export const searchUserScore = (params) => {
    return request({
        url: '/admin-api/tezhao/compet/user/searchUserScore',
        method: 'get',
        params
    })
}

export const listCompetInfo = (params) => {
    return request({
        url: '/admin-api/tezhao/compet/manage/listCompetInfo',
        method: 'get',
        params
    })
}

// 根据字典类型查询字典数据信息
export function getDicts(dictType) {
    return request({
        url: '/admin-api/system/dict-data/list',
        method: 'get',
        params: { dictType }
    })
}

//年级
export function getGradeList(params) {
    return request({ url: '/admin-api/tezhao/compet/grade/treelist', method: 'get', params })
}

//查询教师竞赛证书
export const listTeacher = (params) => {
    return request({
        url: '/admin-api/tezhao/compet/teacher/listTeacher',
        method: 'get',
        params
    })
}


// WEBPACK FOOTER //
// ./src/api/home.js